import { thresholdValue } from './const';
import { IPoint2d } from './IPoint2d';
import { Point2dUtils } from './Point2dUtils';

export class Ray2d {
  private _origin: IPoint2d;
  private _direction: IPoint2d;

  constructor(origin: IPoint2d, direction: IPoint2d) {
    this._origin = origin;
    this._direction = direction;
  }

  get origin(): IPoint2d {
    return this._origin;
  }

  get direction(): IPoint2d {
    return this._direction;
  }

  rotate(angle: number) {
    this._direction = Point2dUtils.rotateDirection(this.direction, angle);
  }

  pointOnRay(point: IPoint2d): boolean {
    const dx = point.x - this._origin.x;
    const dy = point.y - this._origin.y;
    const directionLength = Math.hypot(this._direction.x, this._direction.y);
    if (directionLength < thresholdValue) {
      return Math.hypot(dx, dy) < thresholdValue;
    }

    // 先判断点是否在射线所在直线上，再判断是否在射线正向
    const cross = dx * this._direction.y - dy * this._direction.x;
    if (Math.abs(cross) > thresholdValue * directionLength) {
      return false;
    }

    return dx * this._direction.x + dy * this._direction.y >= -thresholdValue;
  }
}
